export default "__VITE_ASSET__5d1a7f69__"